export const MODULE_NAME = 'app';
export const LOCAL_STORAGE_KEY = 'mewsCommander';
